export const BASE_URL =process.env.REACT_APP_BASEURL;
export const FrontEnd =process.env.REACT_APP_FRONTENDURL;

